/**
 * Hello Greeting Client Mod 定义
 *
 * 前端业务 Mod，提供 Greeting 列表页面（/greetings）和相关 UI 资源。
 * 消费后端 @hvsin/mod-hello-sqlite 注册的 /api/greetings 接口。
 */
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG, GLOBAL_STATE_REGISTRY_INTERFACE_TAG, COMPONENT_REGISTRY_INTERFACE_TAG, HOOKS_REGISTRY_INTERFACE_TAG, } from '@hvsin/ui-registry-contracts';
import { HelloGreetingRegistrar } from './hello-greeting-registrar.js';
/**
 * hello-greeting-client-mod
 *
 * 前端注册模式：Greeting 页面、状态、组件、Hook。
 */
export const helloGreetingClientMod = {
    name: 'hello-greeting-client',
    modDependencies: ['ui-registry'],
    serviceDefs: [
        {
            serviceTag: 'greetingRegistrar',
            serviceImpl: HelloGreetingRegistrar,
            dependencies: [
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                GLOBAL_STATE_REGISTRY_INTERFACE_TAG,
                COMPONENT_REGISTRY_INTERFACE_TAG,
                HOOKS_REGISTRY_INTERFACE_TAG,
            ],
        },
    ],
};
//# sourceMappingURL=mod.js.map